import React from "react";
import cn from "classnames";
import { TooltipIcon } from "./TooltipIcon";

export const ToggleCard = ({
    title,
    subtitle,
    checked,
    onChange,
    className,
    tooltipText
}) => {
    return (
        <button
            type="button"
            onClick={onChange}
            className={cn(
                "flex items-center justify-between w-full px-5 py-4 min-h-[86px] rounded-[16px] border text-left",
                {
                    "bg-[#2B3135] border-transparent": checked,
                    "border-white/[12%]": !checked
                },
                className
            )}
        >
            <div className="pr-2 flex items-center gap-2 flex-1 min-w-0">
                <div className="min-w-0"> 
                <span className="block text-white text-sm leading-[22px]">{title}</span>
                {subtitle && (
                    <span className="block text-[#FFE8AE] text-xs leading-[20px] pt-[3px]">{subtitle}</span>
                )}
                 </div>

                {tooltipText && (
                    <TooltipIcon text={tooltipText} />
                )}
            </div>
            <span className={cn("w-[44px] h-[24px] rounded-full p-[2px] transition-colors flex-shrink-0", checked ? "bg-[#9DCF4E]" : "bg-[#2B3135]")}> 
                <span className={cn("block w-[20px] h-[20px] bg-white rounded-full transition-transform", checked ? "translate-x-[20px]" : "translate-x-0")}/>
            </span>
        </button>
    );
};



